$(document).ready(function () {
    createBetterPagination();
});

document.addEventListener('ShoptetDOMContentLoaded', function () {
    createBetterPagination();
});

function createBetterPagination() {
    const $pagination = $('.pagination__list');

    if (!$pagination.length) {
        return;
    }

    const currentPage = getCurrentPaginationPage();
    const lastPage = getLastPaginationPage(currentPage);

    if (!currentPage || !lastPage || lastPage <= 1) {
        return;
    }

    const prevLink = $('.pagination__link--prev').attr('href') || '';
    const nextLink = $('.pagination__link--next').attr('href') || '';

    const paginationBase = getPaginationBase(prevLink, nextLink);
    const linksMap = getExistingPaginationLinks();

    function getPageUrl(page) {
        if (linksMap[page]) {
            return linksMap[page];
        }

        if (page === 1) {
            return paginationBase.cleanPath + paginationBase.query;
        }

        return paginationBase.cleanPath + 'strana-' + page + '/' + paginationBase.query;
    }

    const pages = getVisiblePaginationPages(currentPage, lastPage);

    let html = '';

    if (currentPage > 1) {
        const prevUrl = prevLink || getPageUrl(currentPage - 1);

        html += `
            <li class="prev">
                <a class="pagination__link pagination__link--prev btn btn-secondary" href="${prevUrl}">
                    ${translation('predchozi')}
                </a>
            </li>
        `;
    }

    if (pages[0] > 1) {
        html += `
            <li>
                <a class="pagination__link pagination__link--first" href="${getPageUrl(1)}">1</a>
            </li>
        `;

        if (pages[0] > 2) {
            html += `<li class="pagination__dots">...</li>`;
        }
    }

    pages.forEach(function (page) {
        if (page === currentPage) {
            html += `
                <li>
                    <strong class="pagination__currentPage" aria-current="page">${page}</strong>
                </li>
            `;
        } else {
            html += `
                <li>
                    <a class="pagination__link" href="${getPageUrl(page)}">${page}</a>
                </li>
            `;
        }
    });

    if (pages[pages.length - 1] < lastPage) {
        if (pages[pages.length - 1] < lastPage - 1) {
            html += `<li class="pagination__dots">...</li>`;
        }

        html += `
            <li>
                <a class="pagination__link pagination__link--last" href="${getPageUrl(lastPage)}">${lastPage}</a>
            </li>
        `;
    }

    if (currentPage < lastPage) {
        const nextUrl = nextLink || getPageUrl(currentPage + 1);

        html += `
            <li class="next">
                <a class="pagination__link pagination__link--next btn btn-secondary" href="${nextUrl}">
                    ${translation('dalsi')}
                </a>
            </li>
        `;
    }

    $pagination.html(html);
}

function getCurrentPaginationPage() {
    const currentPage = parseInt($('.pagination__currentPage').text().trim(), 10);

    if (currentPage) {
        return currentPage;
    }

    return 1;
}

function getLastPaginationPage(currentPage) {
    const lastFromLink = parseInt($('.pagination__link--last').text().trim(), 10);

    if (lastFromLink) {
        return lastFromLink;
    }

    const statusText = $('#paginationStatus').text().trim();
    const statusMatch = statusText.match(/z\s+(\d+)/);

    if (statusMatch && statusMatch[1]) {
        return parseInt(statusMatch[1], 10);
    }

    const lastFromAllLinks = $('.pagination__link')
        .map(function () {
            return parseInt($(this).text().trim(), 10);
        })
        .get()
        .filter(function (page) {
            return !isNaN(page);
        })
        .sort(function (a, b) {
            return b - a;
        })[0];

    return lastFromAllLinks || currentPage;
}

function getPaginationBase(prevLink, nextLink) {
    let sampleUrl =
        nextLink ||
        $('.pagination__link--last').attr('href') ||
        prevLink ||
        $('.pagination__link--first').attr('href') ||
        window.location.pathname + window.location.search;

    const urlParts = sampleUrl.split('?');
    const path = urlParts[0];
    const query = urlParts[1] ? '?' + urlParts[1] : '';

    let cleanPath = path.replace(/strana-\d+\//, '');

    if (typeof shoptet !== 'undefined' && shoptet.content && shoptet.content.regexp) {
        cleanPath = cleanPath.replace(shoptet.content.regexp, '');
    }

    return {
        cleanPath: cleanPath,
        query: query
    };
}

function getExistingPaginationLinks() {
    const linksMap = {};

    $('.pagination__link').each(function () {
        const page = parseInt($(this).text().trim(), 10);
        const href = $(this).attr('href');

        if (!isNaN(page) && href && href !== '#') {
            linksMap[page] = href;
        }
    });

    return linksMap;
}

function getVisiblePaginationPages(currentPage, lastPage) {
    let pages = [];

    if (currentPage <= 2) {
        pages = [1, 2, 3];
    } else if (currentPage >= lastPage - 1) {
        pages = [lastPage - 2, lastPage - 1, lastPage];
    } else {
        pages = [currentPage - 1, currentPage, currentPage + 1];
    }

    return pages.filter(function (page) {
        return page > 0 && page <= lastPage;
    });
}